import { createSelector } from '@ngrx/store';
import * as fromRouter from '../../../core/store';

export const getFilterParams = createSelector(
  fromRouter.getQueryParams,
  (query: { [key: string]: any }) => query && query.filter,
);

export const hasFilters = createSelector(
  getFilterParams,
  (filter: { [key: string]: any }) => !!(filter)
);

// catalog selectors
export const getSearchQuery = createSelector(fromRouter.getQueryParams,
  (query: { [key: string]: any }) => query && query.q);

export * from './products/products.selectors';
export * from './sort/sort.selectors';
export * from './custom-plp/custom-plp.selector';
